import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Health factor',
  description:
    'The health factor represents the safety of your loan derived from the proportion of collateral versus amount borrowed. Keep it above 1 to avoid liquidation.',

  notificationIconTooltipText: 'Set up notification when your Health Factor is getting low.',
});
